import * as React from 'react';
import * as intl from 'react-intl-universal';
import { InboxOutlined, PlusOutlined } from '@ant-design/icons';
import { message, Modal, Upload } from 'antd';
import Button from 'common/components/Button';
import Loading from 'common/components/Loading';
import PDF from 'common/components/PDF';
import { ConfigConsumer, ConfigConsumerProps } from 'common/components/Page/Core';
import utils from 'common/utils/upload';
import { upload } from 'pc-sales/utils/http';
import languages from 'common/i18n/utils/languages';
import RcViewer from "@hanyk/rc-viewer";
import formatter from 'common/utils/formatter';
const Dragger = Upload.Dragger;

interface UploaderProps {
    lang?: string;
    addClass?: string;
    accept?: string;
    action: string;
    disabled?: boolean;
    tips?: string;
    max?: number;
    value?: any;
    onPreview?: Function;
    onChange?: Function;
    transBg?: boolean;
    widthAuto?: boolean;
    discompress?: boolean; // 是否进行压缩,
    fileList?: Array<any>;
    before?: Function;
    limitType?: string;
}

export default class Uploader extends React.Component<UploaderProps> {
    static defaultProps = {
        action: '/',
        max: 50,
    };

    private locales: any = {};
    private values: any[] = [];

    getThumbUrl = (config: any): any => {
        return formatter.contact.relativeUrl(config.aws || config.url);
        // for (let item of Object.entries(config)) {
        //     if (item && item[0] && `${item[1]}`.includes('http')) {
        //         return item[1];
        //     }
        // }
    };

    getDefaultFileTypeUrl = (fileType: string) => {
        if (fileType == 'AI') {
            return window.config.img_file('/images/advertisingAi.png');
        } else if (fileType == 'PSD') {
            return window.config.img_file('/images/advertisingPS.png');
        } else {
            return '';
        }
    }

    private formatter = {
        values: (values: Array<any>, fileType?: string) =>
            (values || [])
                .filter((url: any) => !!url)
                .map((url: any, index: number) => ({
                    uid: this.getThumbUrl(url),
                    index: index,
                    url: this.getThumbUrl(url),
                    thumbUrl: this.getDefaultFileTypeUrl(fileType)||this.getThumbUrl(url),
                    aws: this.getThumbUrl(url),
                    oss: this.getThumbUrl(url),
                    status: 'done'
                }))
    };

    state: {
        isLoading: boolean,
        previewVisible: boolean,
        previewImage: string,
        fileList: Array<any>
    } = {
            isLoading: false,
            previewVisible: false,
            previewImage: '',
            fileList: this.formatter.values(this.props.value, this.props.limitType)
        };

    initData = false;
    showInitData = false;
    limitType = "";
    componentDidMount() {
        const { lang, limitType } = this.props;
        this.locales = utils.getLocales(lang || languages.getDefault() || 'zh-CN');
        this.limitType = limitType;
    }

    UNSAFE_componentWillReceiveProps({ value, fileList: defaultFileList, limitType }: any) {
        // 表单数据回写 (can be more enhancement, maybe)
        if (this.limitType && this.limitType != limitType) {
            this.values = [];
            this.setState({ fileList: [] });
            this.limitType = limitType;
            return;
        }
        this.setState({ fileList: this.formatter.values(value, this.props.limitType) });
        if (!this.initData && defaultFileList) {
            const { onChange } = this.props;
            this.values = this.values.concat(this.formatter.values(defaultFileList, this.props.limitType));
            onChange(defaultFileList);
            this.initData = true;
        }
        this.limitType = limitType;
    }

    /**
     * 取消预览
     */
    cancelHandler = () => this.setState({ previewVisible: false });

    /**
     * 打开预览
     * @param file
     */
    previewHandler = (file: any) => {
        const { disabled, onPreview } = this.props;
        if (typeof onPreview === 'function' && !disabled) {
            onPreview(file.thumbUrl);
        } else {
            this.setState({
                previewImage: file.thumbUrl,
            });
            const { viewer } = this.viewer.getViewer();

            viewer.view(file.index); // View the n image
        }
    };

    /**
     * 上传前校验
     * @param file
     */
    beforeUpload = (file: any, fileList: any): boolean | Promise<any> => {
        if (fileList.length + this.values.length > 50) {
            message.error(intl.get('Ad.MaxUploadTips'));
            return false;
        }
        const { before } = this.props;
        if (before && !before(file)) {
            return false;
        }
        const { type } = file;
        if (type.split('/')[0] !== 'image') {
            message.error(this.locales.type);
            return false;
        }
        if (this.state.isLoading) {
            return false;
        }
        return file;
    };

    /**
     * 文件压缩
     * @param file
     * @param src
     */
    filePress = (file: any, src: any) => utils.imagePress({
        file,
        src,
        quality: 0.2,
        transBg: this.props.transBg,
        widthAuto: this.props.widthAuto
    }, (blob: any) => {
        this.doUpload(file, blob);
    });

    /**
     * 文件不压缩下载控制
     */
    disPressHandler = (file: any) => {
        // 超过3m不进行下载
        if (file.size > 3 * 1024 * 1024) {
            message.error(this.locales.disPressSize);
            this.setState({ isLoading: false });
        } else {
            this.doUpload(file);
        }
    };

    /**
     * 上传函数
     */
    doUpload = (file: any, blob?: any) => {
        const { action, onChange, fileList: defaultFileList } = this.props;
        upload(action, { file: blob ? blob : file }).then(({ url }: any) => {
            const fileList = this.showInitData ? [...this.state.fileList, file] : [...this.formatter.values(defaultFileList, this.props.limitType), file];
            this.showInitData = true;
            this.values.push(url);
            this.setState({ fileList, isLoading: false });
            onChange(this.values.length ? this.values : null);
        }).catch(() => {
            message.error(this.locales.error);
            this.setState({ isLoading: false });
        });
    };

    /**
     * 上传
     * @param file
     */
    uploadHandler = ({ file }: any) => {
        const { discompress } = this.props;
        const reader = new FileReader();
        this.setState({ isLoading: true });
        reader.onloadend = () => {
            const src = reader.result;
            // 是否进行压缩
            discompress ? this.disPressHandler(file) : this.filePress(file, src);
        };
        reader.readAsDataURL(file);
    };

    /**
     * 删除
     * @param {any} file
     */
    removeHandler = (file: any) => {
        const { disabled, onChange } = this.props;
        if (disabled) {
            return false;
        } else {
            const fileList = this.state.fileList.filter((item: any) => item.thumbUrl !== file.thumbUrl);
            this.values = this.values.filter((item: any) => item.aws !== file.thumbUrl);
            this.setState({ fileList });
            onChange(this.values.length ? this.values : null);
            return file;
        }
    };

    /**
     * 下载
     * @returns {any}
     */
    downloadHandler = () => {
        const { previewImage } = this.state;
        const aTag = document.createElement('a');
        aTag.setAttribute("type", "hidden"); // make it hidden if needed
        aTag.href = `/v2/common/file/download?uri=${previewImage}`;
        document.body.appendChild(aTag);
        aTag.click();
        aTag.remove();
    };
    private viewer: any;

    fnRef = (el: any) => this.viewer = el;

    render() {
        const { accept, disabled, tips, max, addClass, widthAuto, limitType } = this.props;
        let { previewVisible, previewImage, fileList, isLoading } = this.state;
        const showPreviewIcon = limitType == 'JPG' || limitType == 'PNG' || limitType == 'PDF' || limitType == 'GIF';
        return (
            <div id="uploadNew" className={disabled ? "clearfix Upload-disabled Upload-hide" : "clearfix"}>
                <Upload accept={accept} listType="picture-card" fileList={fileList} multiple={true} showUploadList={{ showPreviewIcon, showRemoveIcon: false, showDownloadIcon: true }}
                    onPreview={this.previewHandler} beforeUpload={this.beforeUpload} disabled={disabled}
                    className={addClass} customRequest={this.uploadHandler} onRemove={this.removeHandler}>
                    {(!max || fileList.length < max) && (
                        !disabled && <Loading enabled={isLoading} >
                            <PlusOutlined />
                            <div className="ant-upload-text">{intl.get('Component.UploadUpload')}</div>
                        </Loading>
                    )}
                </Upload>
                {tips && <p style={{ fontSize: '12px', color: "rgb(148, 144, 144)" }}>{tips}</p>}
                <Modal visible={previewVisible} onCancel={this.cancelHandler}
                    title={intl.get('Global.CheckImage')}
                    okText={intl.get('Global.Download')}
                    onOk={this.downloadHandler}
                    style={widthAuto ? { maxWidth: 'max-content', minWidth: 360 } : {}}
                    width={widthAuto ? 650 : 520}
                    maskClosable={false}>
                    <img alt={""} style={widthAuto ? { margin: '0 auto', display: 'block' } : { width: '100%' }}
                        src={previewImage} />
                </Modal>
                <RcViewer ref={this.fnRef}>
                    <ul id="images" style={{ display: 'none' }}>
                        {
                            fileList.map(({ url, thumbUrl }, num: number) => <li key={num}><img
                                src={thumbUrl || (url && url.aws)} alt="" />
                            </li>)
                        }
                    </ul>
                </RcViewer>
            </div>
        );
    }
}

interface FileUploadProps {
    action?: string;
    value?: any;
    accept?: string;
}

export class FileUploadNew extends React.Component<any, FileUploadProps> {
    private core: any;
    // private intl: { [key: string]: string; };
    static defaultProps: Partial<FileUploadProps> = {
        action: '/v2/common/file/upload',
        accept: 'pdf'
    };

    constructor(props: FileUploadProps) {
        super(props);
        // 国际化文案
        //   this.intl = utils.getLocales(languages.getDefault());
    }

    // 格式化文件列表
    private get file() {
        const { value } = this.props;
        if (!value) return null;
        if (!value.src) return value;
        for (let item of Object.entries(value.src)) {
            if (item && item[0] && item[1]) {
                const path = typeof item[1] === 'string' && (item[1] as any).split('/');
                return { ...value, src: item[1], name: path[path.length - 1] };
            }
        }
        return value;
    }

    // 可接受文件类型
    private get accept() {
        const { accept } = this.props;
        return ({
            pdf: ['application/pdf'],
            excel: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
        } as any)[accept] || ['application/pdf'];
    }

    // save ref
    private saveRef = (ctx: any) => this.core = ctx;

    // 文件流处理 (todo: 断点、分割上传)
    // private fileChangeHandler = (file: any) => {
    //     if (!this.core) return;
    //     const core = new FileReader();
    //     const { action, onChange } = this.props;
    //     core.readAsDataURL(file);
    //     core.onload = async (e: any) => upload(action, { file }).then((res => {
    //         console.log(res);
    //     }));
    // };

    // 是否正在上传
    private get loading() {
        const { value } = this.props;
        return value && value.status === 'loading';
    }

    // 获取报错语言包
    // private getIntlName() {
    //     const { accept } = this.props;
    //     return ({
    //         pdf: this.intl.pdf,
    //         excel: this.intl.excel
    //     } as any)[accept] || this.intl.pdf;
    // }

    // 文件上传控制
    private uploadHandler = () => {
        if (!this.core) return;
        this.core.click();
        this.core.onchange = (): any => {
            const file = this.core.files[0];
            if (!file || this.loading) return;
            if (!this.accept.includes(file.type)) return message.error(intl.get('Ad.PDFUploadTypeTips'));
            if (file.size > 50 * 1024 * 1024) return message.error(intl.get('Ad.UploadMaxSizeTips'));
            const { action, onChange } = this.props;
            onChange({ name: file.name, status: 'loading' });
            upload(action, { file })
                .then(((res: any) => onChange({ name: file.name, src: res.url, status: 'success' })))
                .catch(() => onChange({ name: file.name, src: null, status: 'error' }));
        };
    };

    // pdf 预览
    private renderPDF = ({ className, src }: any) => {
        return <div className={className}><PDF src={src} /></div>;
    };

    // 渲染上传组件
    private renderComponent = ({ getPrefixCls }: ConfigConsumerProps) => {
        const prefixCls = getPrefixCls("fileUpload");
        const { accept, extra } = this.props;
        const file = this.file || {};
        const src = formatter.contact.relativeUrl(file.src);
        return <div className={prefixCls}>
            <input type="file" accept={this.accept.join(',')} ref={this.saveRef} style={{ display: "none" }}/>
            <Button onClick={this.uploadHandler} loading={this.loading}>{intl.get('Component.UploadFile')}</Button>
            {!!extra && extra}
            {!!file.name && <p style={{ margin: '10px 5px 0' }}><a href={src} target="_blank">{file.name}</a></p>}
            {!!file.src && accept === 'pdf' && this.renderPDF({ className: `${prefixCls}-preview`, src: src })}
        </div>;
    };

    render() {
        return <ConfigConsumer>{this.renderComponent}</ConfigConsumer>;
    }
}

export class ExcelUploadNew extends React.Component<any> {
    state: any = {
        fileList: []
    };

    // 类型判断
    beforeUpload = (file: any) => {
        const ext = file.name.substr(file.name.lastIndexOf('.') + 1);
        const { extension } = this.props;
        if ((extension && extension.includes(ext)) || (!extension && ext === 'csv')) {
            const { fileList } = this.state;
            const value = [...fileList, file];
            this.setState({ fileList: value });
            this.triggerChange(value);
        } else {
            message.error(intl.get(`Component.UploadSupportExtension`, {
                extension: extension ? extension.join(',') : 'csv'
            }));
        }
        return false;
    };

    // 触发更新
    triggerChange = (value: any) => {
        const onChange = this.props.onChange;
        if (onChange) onChange(value);
    };

    // 删除文件
    removeHandler = (file: any) => {
        const { fileList } = this.state;
        const value = fileList.slice();
        value.splice(fileList.indexOf(file), 1);
        this.setState({ fileList: value });
        this.triggerChange(value);
    };

    render() {
        const { fileList } = this.state;
        const { templateUrl, extension, text } = this.props;
        return (
            <div className="text-center" style={{ marginTop: 16, height: 180 }}>
                <Dragger
                    fileList={fileList}
                    onRemove={this.removeHandler}
                    beforeUpload={this.beforeUpload}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                        {text || intl.get('Component.UploadDefaultText')}
                    </p>
                    <p className="ant-upload-hint">
                        {templateUrl
                            && <a href={templateUrl}
                                onClick={(e: any) => e.stopPropagation()}>
                                {intl.get('Component.UploadDownloadTemplate')}
                            </a>}
                        {`(${intl.get(`Component.UploadSupportExtension`, {
                            extension: extension ? extension.join(',') : 'csv'
                        })})`}
                    </p>
                </Dragger>
            </div>
        );
    }
}
